import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "80px 20px", maxWidth: "900px", margin: "auto" }}>
      <h1>Privacy Policy</h1>

      <p>
        Welcome to UPIN Trading Corporation. Your privacy is important to us.
      </p>

      <h3>Information We Collect</h3>
      <p>
        We may collect your name and mobile number only for business communication and order processing.
      </p>

      <h3>How We Use Information</h3>
      <p>
        We use your information only to contact you regarding your inquiries or orders.
        We do not sell or share your personal data.
      </p>

      <h3>Security</h3>
      <p>
        We take reasonable steps to protect your data.
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have any questions, contact us at sakethpabbathi@gmail.com
      </p>
    </div>
  );
};

export default PrivacyPolicy;